import React from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import { deleteLot } from 'js/services/lot'
import { Table } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Paths from 'js/utils/paths'
import { LotDeviceInfo } from 'js/services/report-models'
import { DeviceType } from 'js/models'
import { formatDate } from 'js/utils/helpers'

export const deleteLotModal = (
  lotId: number,
  showConfirmDelete: boolean,
  handleCloseConfirmDelete: () => void
): React.ReactElement => {
  return (
    <Modal show={showConfirmDelete} onHide={handleCloseConfirmDelete}>
      <Modal.Header className='bg-danger'>
        <Modal.Title className='text-white'>
          Delete Lot from Lot Group
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        This lot will immediatedly be deleted from the lot group.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleCloseConfirmDelete}>
          Cancel
        </Button>
        <Button
          variant='outline-danger'
          onClick={(): void => {
            deleteLot(lotId).then(() => location.reload())
          }}
        >
          Delete Lot
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export interface LotDeviceModalInfo {
  deviceType: DeviceType
  lotDeviceInfo: LotDeviceInfo[]
}

export const LotDeviceInfoModal = (props: {
  show: boolean
  onClose: () => void
  modalInfo?: LotDeviceModalInfo
}): React.ReactElement => {
  const { show, onClose, modalInfo } = props
  const navigate = useNavigate()
  const sortedLotDeviceInfo = modalInfo?.lotDeviceInfo.sort((a, b) =>
    a.organizationName.localeCompare(b.organizationName)
  )

  return (
    <Modal show={show} onHide={onClose} size='lg'>
      <Modal.Header>
        <Modal.Title>{modalInfo?.deviceType.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table striped hover className='table-header-primary'>
          <thead>
            <tr>
              <th>Organization</th>
              <th>Site Name</th>
              <th># Data Points</th>
              <th>Last Edited</th>
            </tr>
          </thead>
          <tbody>
            {sortedLotDeviceInfo?.map(row => (
              <tr
                key={`lot-device-row-${row.deviceSite}-${row.siteName}`}
                className='clickable'
                onClick={(): void => {
                  navigate(Paths.getAdminOrganizationDetailLink(row.organization))
                }}
              >
                <td>{row.organizationName}</td>
                <td>{row.siteName}</td>
                <td>{row.count}</td>
                <td>{formatDate(row.lastEdit)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
